// Ce fichier est généré automatiquement par utils/spritesheet-config-generator
// Ne pas modifier manuellement
// Dossier: effects | Taille: 550x550px | Directions: 1

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const EffectsSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'effects-omnislash',
    metadata: {
      frames: {
        'effects-omnislash-0': {
          frame: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-1': {
          frame: {
            x: 550,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-2': {
          frame: {
            x: 1100,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-3': {
          frame: {
            x: 1650,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-4': {
          frame: {
            x: 2200,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-5': {
          frame: {
            x: 2750,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-6': {
          frame: {
            x: 3300,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-7': {
          frame: {
            x: 3850,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-8': {
          frame: {
            x: 4400,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-9': {
          frame: {
            x: 4950,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-10': {
          frame: {
            x: 5500,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-11': {
          frame: {
            x: 6050,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-12': {
          frame: {
            x: 6600,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-13': {
          frame: {
            x: 7150,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-14': {
          frame: {
            x: 7700,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-15': {
          frame: {
            x: 8250,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-16': {
          frame: {
            x: 8800,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-17': {
          frame: {
            x: 9350,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-18': {
          frame: {
            x: 9900,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-omnislash-19': {
          frame: {
            x: 10450,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
      },
      meta: {
        image: '/sprites/effects/omnislash.png',
        size: {
          w: 11000,
          h: 550,
        },
        scale: '1',
      },
      animations: {
        'effects-omnislash': [
          'effects-omnislash-0',
          'effects-omnislash-1',
          'effects-omnislash-2',
          'effects-omnislash-3',
          'effects-omnislash-4',
          'effects-omnislash-5',
          'effects-omnislash-6',
          'effects-omnislash-7',
          'effects-omnislash-8',
          'effects-omnislash-9',
          'effects-omnislash-10',
          'effects-omnislash-11',
          'effects-omnislash-12',
          'effects-omnislash-13',
          'effects-omnislash-14',
          'effects-omnislash-15',
          'effects-omnislash-16',
          'effects-omnislash-17',
          'effects-omnislash-18',
          'effects-omnislash-19',
        ],
      },
    },
  },
  {
    name: 'effects-demon-slash',
    metadata: {
      frames: {
        'effects-demon-slash-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-bottom-1': {
          frame: {
            x: 550,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-bottom-2': {
          frame: {
            x: 1100,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-bottom-3': {
          frame: {
            x: 1650,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-bottom-4': {
          frame: {
            x: 2200,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-bottom-5': {
          frame: {
            x: 2750,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-left-0': {
          frame: {
            x: 0,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-left-1': {
          frame: {
            x: 550,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-left-2': {
          frame: {
            x: 1100,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-left-3': {
          frame: {
            x: 1650,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-left-4': {
          frame: {
            x: 2200,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-left-5': {
          frame: {
            x: 2750,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-top-0': {
          frame: {
            x: 0,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-top-1': {
          frame: {
            x: 550,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-top-2': {
          frame: {
            x: 1100,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-top-3': {
          frame: {
            x: 1650,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-top-4': {
          frame: {
            x: 2200,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-demon-slash-top-5': {
          frame: {
            x: 2750,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
      },
      meta: {
        image: '/sprites/effects/demon-slash.png',
        size: {
          w: 3300,
          h: 1650,
        },
        scale: '1',
      },
      animations: {
        'effects-demon-slash-bottom': [
          'effects-demon-slash-bottom-0',
          'effects-demon-slash-bottom-1',
          'effects-demon-slash-bottom-2',
          'effects-demon-slash-bottom-3',
          'effects-demon-slash-bottom-4',
          'effects-demon-slash-bottom-5',
        ],
        'effects-demon-slash-bottom-left': [
          'effects-demon-slash-bottom-0',
          'effects-demon-slash-bottom-1',
          'effects-demon-slash-bottom-2',
          'effects-demon-slash-bottom-3',
          'effects-demon-slash-bottom-4',
          'effects-demon-slash-bottom-5',
        ],
        'effects-demon-slash-top-left': [
          'effects-demon-slash-bottom-0',
          'effects-demon-slash-bottom-1',
          'effects-demon-slash-bottom-2',
          'effects-demon-slash-bottom-3',
          'effects-demon-slash-bottom-4',
          'effects-demon-slash-bottom-5',
        ],
        'effects-demon-slash-left': [
          'effects-demon-slash-left-0',
          'effects-demon-slash-left-1',
          'effects-demon-slash-left-2',
          'effects-demon-slash-left-3',
          'effects-demon-slash-left-4',
          'effects-demon-slash-left-5',
        ],
        'effects-demon-slash-top': [
          'effects-demon-slash-top-0',
          'effects-demon-slash-top-1',
          'effects-demon-slash-top-2',
          'effects-demon-slash-top-3',
          'effects-demon-slash-top-4',
          'effects-demon-slash-top-5',
        ],
      },
    },
  },
  {
    name: 'effects-wide-axe',
    metadata: {
      frames: {
        'effects-wide-axe-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-bottom-1': {
          frame: {
            x: 550,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-bottom-2': {
          frame: {
            x: 1100,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-bottom-3': {
          frame: {
            x: 1650,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-bottom-4': {
          frame: {
            x: 2200,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-bottom-5': {
          frame: {
            x: 2750,
            y: 0,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-left-0': {
          frame: {
            x: 0,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-left-1': {
          frame: {
            x: 550,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-left-2': {
          frame: {
            x: 1100,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-left-3': {
          frame: {
            x: 1650,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-left-4': {
          frame: {
            x: 2200,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-left-5': {
          frame: {
            x: 2750,
            y: 550,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-top-0': {
          frame: {
            x: 0,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-top-1': {
          frame: {
            x: 550,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-top-2': {
          frame: {
            x: 1100,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-top-3': {
          frame: {
            x: 1650,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-top-4': {
          frame: {
            x: 2200,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
        'effects-wide-axe-top-5': {
          frame: {
            x: 2750,
            y: 1100,
            w: 550,
            h: 550,
          },
          sourceSize: {
            w: 550,
            h: 550,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 550,
            h: 550,
          },
        },
      },
      meta: {
        image: '/sprites/effects/wide-axe.png',
        size: {
          w: 3300,
          h: 1650,
        },
        scale: '1',
      },
      animations: {
        'effects-wide-axe-bottom': [
          'effects-wide-axe-bottom-0',
          'effects-wide-axe-bottom-1',
          'effects-wide-axe-bottom-2',
          'effects-wide-axe-bottom-3',
          'effects-wide-axe-bottom-4',
          'effects-wide-axe-bottom-5',
        ],
        'effects-wide-axe-left': [
          'effects-wide-axe-left-0',
          'effects-wide-axe-left-1',
          'effects-wide-axe-left-2',
          'effects-wide-axe-left-3',
          'effects-wide-axe-left-4',
          'effects-wide-axe-left-5',
        ],
        'effects-wide-axe-bottom-left': [
          'effects-wide-axe-left-0',
          'effects-wide-axe-left-1',
          'effects-wide-axe-left-2',
          'effects-wide-axe-left-3',
          'effects-wide-axe-left-4',
          'effects-wide-axe-left-5',
        ],
        'effects-wide-axe-top-left': [
          'effects-wide-axe-left-0',
          'effects-wide-axe-left-1',
          'effects-wide-axe-left-2',
          'effects-wide-axe-left-3',
          'effects-wide-axe-left-4',
          'effects-wide-axe-left-5',
        ],
        'effects-wide-axe-top': [
          'effects-wide-axe-top-0',
          'effects-wide-axe-top-1',
          'effects-wide-axe-top-2',
          'effects-wide-axe-top-3',
          'effects-wide-axe-top-4',
          'effects-wide-axe-top-5',
        ],
      },
    },
  },
  {
    name: 'fire',
    metadata: {
      frames: {
        'fire-0': {
          frame: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-1': {
          frame: {
            x: 32,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-2': {
          frame: {
            x: 64,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-3': {
          frame: {
            x: 96,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-4': {
          frame: {
            x: 128,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-5': {
          frame: {
            x: 160,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-6': {
          frame: {
            x: 192,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
        'fire-7': {
          frame: {
            x: 224,
            y: 0,
            w: 32,
            h: 48,
          },
          sourceSize: {
            w: 32,
            h: 48,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 32,
            h: 48,
          },
        },
      },
      meta: {
        image: '/sprites/effects/fire.png',
        size: {
          w: 256,
          h: 48,
        },
        scale: '1',
      },
      animations: {
        fire: [
          'fire-0',
          'fire-1',
          'fire-2',
          'fire-3',
          'fire-4',
          'fire-5',
          'fire-6',
          'fire-7',
        ],
      },
    },
  },
  {
    name: 'effects-attraction',
    metadata: {
      frames: {
        'effects-attraction-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-4': {
          frame: {
            x: 288,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-5': {
          frame: {
            x: 360,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-6': {
          frame: {
            x: 432,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-attraction-7': {
          frame: {
            x: 504,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/attraction.png',
        size: {
          w: 576,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-attraction': [
          'effects-attraction-0',
          'effects-attraction-1',
          'effects-attraction-2',
          'effects-attraction-3',
          'effects-attraction-4',
          'effects-attraction-5',
          'effects-attraction-6',
          'effects-attraction-7',
        ],
      },
    },
  },
  {
    name: 'effects-aura',
    metadata: {
      frames: {
        'effects-aura-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-4': {
          frame: {
            x: 288,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-5': {
          frame: {
            x: 360,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-6': {
          frame: {
            x: 432,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-aura-7': {
          frame: {
            x: 504,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/aura.png',
        size: {
          w: 576,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-aura': [
          'effects-aura-0',
          'effects-aura-1',
          'effects-aura-2',
          'effects-aura-3',
          'effects-aura-4',
          'effects-aura-5',
          'effects-aura-6',
          'effects-aura-7',
        ],
      },
    },
  },
  {
    name: 'effects-fireball-side',
    metadata: {
      frames: {
        'effects-fireball-side-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireball-side-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireball-side-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireball-side-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/fireball-side.png',
        size: {
          w: 288,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-fireball-side': [
          'effects-fireball-side-0',
          'effects-fireball-side-1',
          'effects-fireball-side-2',
          'effects-fireball-side-3',
        ],
      },
    },
  },
  {
    name: 'effects-fireball',
    metadata: {
      frames: {
        'effects-fireball-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireball-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireball-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireball-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/fireball.png',
        size: {
          w: 288,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-fireball': [
          'effects-fireball-0',
          'effects-fireball-1',
          'effects-fireball-2',
          'effects-fireball-3',
        ],
      },
    },
  },
  {
    name: 'effects-fireblast',
    metadata: {
      frames: {
        'effects-fireblast-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireblast-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireblast-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-fireblast-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/fireblast.png',
        size: {
          w: 288,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-fireblast': [
          'effects-fireblast-0',
          'effects-fireblast-1',
          'effects-fireblast-2',
          'effects-fireblast-3',
        ],
      },
    },
  },
  {
    name: 'effects-rock',
    metadata: {
      frames: {
        'effects-rock-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-4': {
          frame: {
            x: 288,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-5': {
          frame: {
            x: 360,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-6': {
          frame: {
            x: 432,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-rock-7': {
          frame: {
            x: 504,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/rock.png',
        size: {
          w: 576,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-rock': [
          'effects-rock-0',
          'effects-rock-1',
          'effects-rock-2',
          'effects-rock-3',
          'effects-rock-4',
          'effects-rock-5',
          'effects-rock-6',
          'effects-rock-7',
        ],
      },
    },
  },
  {
    name: 'effects-root',
    metadata: {
      frames: {
        'effects-root-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-4': {
          frame: {
            x: 288,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-5': {
          frame: {
            x: 360,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-6': {
          frame: {
            x: 432,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-root-7': {
          frame: {
            x: 504,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/root.png',
        size: {
          w: 576,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-root': [
          'effects-root-0',
          'effects-root-1',
          'effects-root-2',
          'effects-root-3',
          'effects-root-4',
          'effects-root-5',
          'effects-root-6',
          'effects-root-7',
        ],
      },
    },
  },
  {
    name: 'effects-smoke',
    metadata: {
      frames: {
        'effects-smoke-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-4': {
          frame: {
            x: 288,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-5': {
          frame: {
            x: 360,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-6': {
          frame: {
            x: 432,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-smoke-7': {
          frame: {
            x: 504,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/smoke.png',
        size: {
          w: 576,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-smoke': [
          'effects-smoke-0',
          'effects-smoke-1',
          'effects-smoke-2',
          'effects-smoke-3',
          'effects-smoke-4',
          'effects-smoke-5',
          'effects-smoke-6',
          'effects-smoke-7',
        ],
      },
    },
  },
  {
    name: 'effects-starfall',
    metadata: {
      frames: {
        'effects-starfall-0': {
          frame: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-1': {
          frame: {
            x: 72,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-2': {
          frame: {
            x: 144,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-3': {
          frame: {
            x: 216,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-4': {
          frame: {
            x: 288,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-5': {
          frame: {
            x: 360,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-6': {
          frame: {
            x: 432,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
        'effects-starfall-7': {
          frame: {
            x: 504,
            y: 0,
            w: 72,
            h: 72,
          },
          sourceSize: {
            w: 72,
            h: 72,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 72,
            h: 72,
          },
        },
      },
      meta: {
        image: '/sprites/effects/starfall.png',
        size: {
          w: 576,
          h: 72,
        },
        scale: '1',
      },
      animations: {
        'effects-starfall': [
          'effects-starfall-0',
          'effects-starfall-1',
          'effects-starfall-2',
          'effects-starfall-3',
          'effects-starfall-4',
          'effects-starfall-5',
          'effects-starfall-6',
          'effects-starfall-7',
        ],
      },
    },
  },
];
